import DataTable from "../../../../../components/DataTable";

const OperatingSystems = ({ results }) => {
  const columns = [
    {
      accessorKey: "ip",
      header: () => <span>Host</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original.ip}</span>,
    },
    {
      accessorKey: "name",
      header: () => <span>Operating System</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original.name}</span>,
    },
  ];
  return (
    <div>
      {results && results.length > 0 && (
        <DataTable columns={columns} data={results} />
      )}
      {results && results.length === 0 && (
        <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
          <p className=" font-semibold text-xl">There are no results</p>
        </div>
      )}
    </div>
  );
};

export default OperatingSystems;
